export default __webpack_public_path__ + "static/media/icn_camera.42f0721c.svg";